import { render, staticRenderFns } from "./SubPlan.vue?vue&type=template&id=65311846&scoped=true&"
import script from "./SubPlan.vue?vue&type=script&lang=js&"
export * from "./SubPlan.vue?vue&type=script&lang=js&"
import style0 from "./SubPlan.vue?vue&type=style&index=0&id=65311846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65311846",
  null
  
)

export default component.exports